import { Button, FileUploader, Form, TextBox } from 'devextreme-react';
import { Label, SimpleItem } from 'devextreme-react/form';
import React, { Component } from 'react';
import MinimalButton from '../MinimalButton';
import Inline from '../Inline';
import TestLogon from './TestLogon';
import OptionButtons from '../utils/OptionButtons';
import { style } from 'typestyle';
import { apiGetP, apiPostNoBodyP, apiPostP } from '../../GanjiTools';
import Home from './Home';


class RegisterUser extends Component {
    state = {
        step: 'RegisterTel',
        stUser: { id: 0, role: '' },
    };

    onRegisterTelP = () => new Promise((resolve, reject) => {
        let role = this.state.stUser?.role;

        if (!(role?.length > 0)) {
            reject?.('لطفاً نقش خود را مشخص کنید');
            return;
        }

        let tel = this.state.tel ?? '';

        if (tel.startsWith('0098'))
            tel = tel.replace('0098', '0');
        else if (tel.startsWith('+98'))
            tel = tel.replace('+98', '0');
        else if (tel.startsWith('989'))
            tel = tel.replace('989', '09');

        if (tel?.length !== 11) {
            reject?.('شماره موبایل خود را به درستی وارد کنید');
            return;
        }

        apiGetP(`/api/rahKala/registerTel?tel=${tel}&role=${role}`)
            .then(res => {
                let { error, stUser } = res ?? { error: 'no response', stUser: null };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                if (!(stUser?.id > 0)) {
                    reject?.('No stUser.');
                    return;
                }
                resolve?.(stUser);
                return;
            })
            .catch(reject);
    });

    onSendVerificationCodeP = () => new Promise((resolve, reject) => {
        if (this.state.stUser?.id > 0) {
            resolve?.(); ////////////////////////////////////////////////////////////////////////
            return;
        }
        reject?.('Invalid stUser.');
    });

    onRegisterPasswordP = () => new Promise((resolve, reject) => {
        if (!(this.state.stUser?.id > 0)) {
            reject?.('کاربر نامعتبر');
            return;
        }

        if (!(this.state.psw1?.length > 0)) {
            reject?.('رمز انتخاب شده بیش از حد کوتاه است');
            return;
        }

        if (this.state.psw1 !== this.state.psw2) {
            reject?.('رمز و تکرار آن یکسان نیستند');
            return;
        }

        apiPostNoBodyP(`/api/rahKala/registerPassword?stUserId=${this.state.stUser.id}&psw=${this.state.psw1}`)
            .then(res => {
                let { error } = res ?? { error: 'No response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve?.();
            })
            .catch(reject);
    });

    onSaveAndCheckOrdererIdentityP = () => new Promise((resolve, reject) => {
        if (this.state.stUser?.role !== 'orderer') {
            reject?.('Invalid orderer role.');
            return;
        }

        let stUserId = this.state.stUser?.id;
        if (!(stUserId > 0)) {
            reject?.('No record id.');
            return;
        }

        let { fname, lname, nationalCode } = this.state;


        apiPostP(`/api/rahKala/saveOrdererInfo?stUserId=${stUserId}`, { fname, lname, nationalCode })
            .then(res => {
                let { error, record } = res ?? { error: 'No response' };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }
                resolve?.(record);
            })
            .catch(reject);
    });

    onGetRecordInfoP = () => new Promise((resolve, reject) => {
        let stUserId = this.state.stUser?.id;

        if (!(stUserId > 0)) {
            reject?.('کاربر نامعتبر');
            return;
        }

        apiGetP(`/api/rahKala/getRecordInfo?stUserId=${stUserId}`)
            .then(res => {
                let { error, record } = res ?? { error: 'No response', record: null };
                if (error?.length > 0) {
                    reject?.(error);
                    return;
                }

                if (!(record?.id > 0)) {
                    reject?.('Record not found.');
                    return;
                }
                resolve?.(record);
            })
            .catch(reject)
    });

    renderRegisterTel = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <OptionButtons itemWidth='6rem'
                items={[
                    { text: 'صاحب بار', icon: 'square-this-way-up', role: 'orderer' },
                    { text: 'شرکت', icon: 'building', role: 'company' },
                    { text: 'راننده', icon: 'truck', role: 'driver' },
                ]}
                style={{ margin: '0 0 2rem 0' }}
                onSelectionChanged={item => {
                    this.state.stUser ??= {};
                    this.state.stUser.role = item?.role ?? '';
                    this.forceUpdate();
                }}
            />

            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='شماره موبایل' />
                    <TextBox placeholder='شماره موبایل خود را وارد کنید' rtlEnabled={false} className='mdh-left-align'
                        value={this.state.tel} onValueChanged={e => this.setState({ tel: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={'fa-user'} text='ثبت نام' width='24rem' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}

                onClick={() => this.onRegisterTelP()
                    .then(stUser => this.setState({ stUser, step: 'SendVerificationCode' }))
                    .catch(window.notif)
                }
            />

            <Inline style={{ marginTop: '1rem', fontSize: '0.9em' }}>
                <div style={{ color: 'gray' }}>قبلاً ثبت نام کرده اید؟</div>
                <MinimalButton text='ورود' style={{ margin: '0 1rem', color: 'blue' }}
                    //onClick={() => window.setInnerBody(<Home mode='logon' />)}
                    onClick={() => window.setFullBody(
                        <TestLogon onSuccessLogon={
                            user => {
                                window.user = user;
                                window.setInnerBody(<Home mode='board' />);
                            }
                        }
                        />
                    )}
                />
            </Inline>
        </div >
    );

    renderRegisterPassword = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='رمز عبور' />
                    <TextBox placeholder='رمز عبور خود را وارد کنید' rtlEnabled={false}
                        className='mdh-left-align' mode='password'
                        value={this.state.psw1} onValueChanged={e => this.setState({ psw1: e.value })}
                    />
                </SimpleItem>
                <SimpleItem colSpan={60}>
                    <Label text='تکرار رمز عبور' />
                    <TextBox placeholder='رمز عبور خود را مجدداً وارد کنید' rtlEnabled={false}
                        className='mdh-left-align' mode='password'
                        value={this.state.psw2} onValueChanged={e => this.setState({ psw2: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={''} text='ثبت' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onRegisterPasswordP()
                    .then(() => this.setState({
                        step: this.state.stUser?.role === 'orderer' ? 'OrdererIndentityInfo' :
                            this.state.stUser?.role === 'driver' ? 'DriverIdentityCheck' :
                                this.state.stUser?.role === 'company' ? 'CompanyIdentityCheck' :
                                    ''
                    }))
                    .catch(window.notif)}
            />
        </div>
    );

    renderSendVerificationCode = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='کد تأیید' />
                    <TextBox placeholder='کد تأیید دریافت شده را وارد کنید' rtlEnabled={false} className='mdh-left-align'
                        value={this.state.verificationCode} onValueChanged={e => this.setState({ verificationCode: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={''} text='ارسال' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onSendVerificationCodeP()
                    .then(() => this.setState({ step: 'RegisterPassword' }))
                    .catch(window.notif)}
            />
        </div>
    );

    renderOrdererIndentityInfo = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='نام' />
                    <TextBox rtlEnabled={false}
                        value={this.state.fname} onValueChanged={e => this.setState({ fname: e.value })}
                    />
                </SimpleItem>
                <SimpleItem colSpan={60}>
                    <Label text='نام خانوادگی' />
                    <TextBox rtlEnabled={false}
                        value={this.state.lname} onValueChanged={e => this.setState({ lname: e.value })}
                    />
                </SimpleItem>
                <SimpleItem colSpan={60}>
                    <Label text='کد ملی' />
                    <TextBox rtlEnabled={false} className='mdh-left-align'
                        value={this.state.nationalCode} onValueChanged={e => this.setState({ nationalCode: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onSaveAndCheckOrdererIdentityP()
                    .then(record => this.setState({ record, step: 'Registered' }))
                    .catch(window.notif)}
            />
        </div>
    );

    renderViewDriverInfo = () => {
        if (this.state.stUser?.role !== 'driver')
            return (<div>BUG: role is not driver.</div>);

        let driver = this.state.record;

        return (
            <div dir='rtl'
                style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
                className='loadorder-card'
            >
                <Form rtlEnabled colCount={60} width='24rem'>
                    <SimpleItem colSpan={60}>
                        <Label text='نام و نام خانوادگی' />
                        <TextBox rtlEnabled={false} readOnly
                            value={driver.fname + ' ' + driver.lname}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={60}>
                        <Label text='وضعیت' />
                        <TextBox rtlEnabled={false} readOnly
                            value={driver.isActive ? 'فعال' : 'غیرفعال'}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={60}>
                        <Label text='تاریخ پایان اعتبار' />
                        <TextBox rtlEnabled={false} className='mdh-left-align' readOnly
                            value={driver.expDate}
                        />
                    </SimpleItem>
                </Form>
                <br />

                <MinimalButton text='کد ملی خود را اشتباه وارد کرده ام' style={{ color: 'maroon' }}
                />
                <br />

                <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                    normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                    normalColor='whitesmoke' highlightedColor='white'
                    spacing='1rem'
                    style={{ padding: '0.5rem', borderRadius: '1rem' }}
                    onClick={() => this.onGetRecordInfoP()
                        .then(record => this.setState({ record, step: 'Registered' }))
                        .catch(window.notif)}
                />
            </div>
        );
    }

    renderViewCompanyInfo = () => {
        if (this.state.stUser?.role !== 'company')
            return (<div>BUG: role is not company.</div>);

        let company = this.state.record;
        return (
            <div dir='rtl'
                style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
                className='loadorder-card'
            >
                <Form rtlEnabled colCount={60} width='24rem'>
                    <SimpleItem colSpan={60}>
                        <Label text='نام شرکت' />
                        <TextBox rtlEnabled={false} readOnly
                            value={company.name}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={60}>
                        <Label text='وضعیت' />
                        <TextBox rtlEnabled={false} readOnly
                            value={company.isActive ? 'فعال' : 'غیرفعال'}
                        />
                    </SimpleItem>
                    <SimpleItem colSpan={60}>
                        <Label text='محل فعالیت شرکت' />
                        <TextBox rtlEnabled={false} readOnly
                            value={company.city}
                        />
                    </SimpleItem>
                </Form>

                <br />

                <MinimalButton text='کد شرکت خود را اشتباه وارد کرده ام' style={{ color: 'maroon' }}
                />

                <br />

                <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                    normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                    normalColor='whitesmoke' highlightedColor='white'
                    spacing='1rem'
                    style={{ padding: '0.5rem', borderRadius: '1rem' }}
                    onClick={() => this.onSaveAndCheckOrdererIdentityP()
                        .then(record => this.setState({ record, step: 'UploadCompanyLicense' }))
                        .catch(window.notif)}
                />
            </div>
        );
    }

    renderDriverIndentityCheck = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='کد ملی' />
                    <TextBox rtlEnabled={false} className='mdh-left-align'
                        value={this.state.nationalCode} onValueChanged={e => this.setState({ nationalCode: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onGetRecordInfoP()
                    .then(record => this.setState({ record, step: 'ViewDriverInfo' }))
                    .catch(window.notif)}
            />
        </div>
    );

    renderCompanyIdentityCheck = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <Form rtlEnabled colCount={60} width='24rem'>
                <SimpleItem colSpan={60}>
                    <Label text='کد شرکت' />
                    <TextBox rtlEnabled={false} className='mdh-left-align'
                        value={this.state.nationalCode} onValueChanged={e => this.setState({ nationalCode: e.value })}
                    />
                </SimpleItem>
            </Form>
            <br />
            <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.onGetRecordInfoP()
                    .then(record => this.setState({ record, step: 'ViewCompanyInfo' }))
                    .catch(window.notif)}
            />
        </div>
    );

    renderUploadCompanyLicense = () => {
        if (this.state.stUser?.role !== 'company')
            return (<div>Wrong company role: {this.state.stUser?.role}</div>);

        return (
            <div dir='rtl'
                style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
                className='loadorder-card'
            >
                <Form rtlEnabled colCount={60} width='24rem'>
                    <SimpleItem colSpan={60}>
                        <Label text='بارگذاری جواز شرکت' />
                        <FileUploader
                        />
                    </SimpleItem>
                </Form>
                <br />
                <MinimalButton icon={'fa-next'} text='مرحله بعد' width='100%' // type='success'
                    normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                    normalColor='whitesmoke' highlightedColor='white'
                    spacing='1rem'
                    style={{ padding: '0.5rem', borderRadius: '1rem' }}
                    onClick={() => this.onCheckCompanyIdentityP()
                        .then(record => this.setState({ record, step: 'Registered' }))
                        .catch(window.notif)}
                />
            </div>
        );
    }

    renderLogon = () => {
        window.user = { id: 0 };

        return (
            <TestLogon onSuccessLogon={
                user => {
                    window.user = user;
                    window.setInnerBody(<Home mode='board' />);
                }
            }
            />
        );
    }

    renderRegistered = () => (
        <div dir='rtl'
            style={{ padding: '3rem', display: 'block', margin: 'auto', background: 'whitesmoke' }}
            className='loadorder-card'
        >
            <div style={{ marginBottom: '2rem' }}>ثبت نام شما با موفقیت انجام شد</div>
            <MinimalButton icon={'fa-next'} text='صفحه ورود' width='100%' // type='success'
                normalBackground='forestgreen' highlightedBackground='#4c9e4c'
                normalColor='whitesmoke' highlightedColor='white'
                spacing='1rem'
                style={{ padding: '0.5rem', borderRadius: '1rem' }}
                onClick={() => this.setState({ step: 'Logon' })}
            />
        </div>
    );

    render() {
        if (this.state.step?.length > 0)
            return (
                <div style={TestLogon.containerStyle}>
                    {this[`render${this.state.step}`]()}
                </div>
            );

        return (
            <div style={TestLogon.containerStyle}>
                <p>Wrong step: {this.state.step}</p>
            </div>
        );
    }
}

export default RegisterUser;